import React, { useEffect, useState } from "react";
import ReactTable from "../../common/react-table/ReactTable";
import Mixpanel from "mixpanel-browser";
import moment from "moment";

import trashImg from "../../assets/images/trash.svg";
import plusicnImg from "../../assets/images/plusicn.svg";
import edit from "../../assets/images/edit.svg";
import ActionImg from "../../assets/images/action.svg";
import { useDispatch, useSelector } from "react-redux";
import { getUserList } from "../../features/userManagement/getUserListSlice";
import ConfirmationModal from "../../common/modal/ConfirmationModal";
import { activateDeactivate } from "../../features/userManagement/activateDeactivateUserSlice";
import { deleteUser } from "../../features/userManagement/deleteUserSlice";
// import { showSuccess } from "../../utils/messageHelper";
import { OK } from "../../constants/statusCode";
import AddUserModal from "./modal/AddUserModal";
import { resetData } from "../../features/userManagement/getParticularUserSlice";
import active_icon from "../../assets/images/active_icon.svg";
import { RoleRightsForModule } from "../../utils/utils";

const AllUsers = ({
  searchValue,
  perPage,
  setCurrentPage,
  setPerPage,
  currentPage,
  setCurrentActiveTab,
  currentActiveTab,
}) => {
  const { userList, total_records } = useSelector((state) => ({
    userList: state?.getUserListReducer?.responseData?.users,
    total_records:
      state?.getUserListReducer?.responseData?.pagination?.total_records,
  }));

  const dispatch = useDispatch();

  const [userId, setuserId] = useState("");
  const [currentModal, setCurrentModal] = useState("");
  let projectData = JSON.parse(localStorage.getItem("_user"));

  useEffect(() => {
    if (currentActiveTab === "allUsers") {
      dispatch(
        getUserList({
          perPage: perPage,
          page: currentPage,
          search: searchValue,
          isActive: 1,
          organization_uuid: projectData?.organizations[0].uuid,
        })
      );
    }
  }, [perPage, currentPage, searchValue, currentActiveTab]);

  const handleTotalPage = (page) => {
    setPerPage(Number(page));
    setCurrentPage(1);
  };

  const handleCurrentPage = (page) => {
    setCurrentPage(Number(page));
  };

  const toggleModal = () => {
    setCurrentModal("");
    setuserId("");
    dispatch(resetData());
  };

  const handleActivateDeactivate = async () => {
    Mixpanel.track("Active/Deactivate user Button Clicked", {
      Page: "Users page",
    });
    const { payload } = await dispatch(activateDeactivate(userId));
    if (payload.status === OK) {
      dispatch(getUserList({ perPage: perPage, page: currentPage, isActive: 1, organization_uuid: projectData?.organizations[0].uuid }));
      toggleModal();
      // showSuccess(payload.data.responseMessage);
    }
  };

  const handleDelete = async () => {
    Mixpanel.track("Delete user Button Clicked", {
      Page: "Users page",
    });
    const { payload } = await dispatch(deleteUser({ userId: userId, organization_uuid: projectData?.organizations[0].uuid }));
    if (payload.status === OK) {
      dispatch(getUserList({ perPage: perPage, page: currentPage, isActive: 1, organization_uuid: projectData?.organizations[0].uuid }));
      toggleModal();
      setCurrentActiveTab("allUsers");
      // showSuccess(payload.data.responseMessage);
    }
  };

  const columns = [
    {
      Header: "Email",
      accessor: (data) => (
        <>
          <span>{data?.email}</span>
        </>
      ),
    },
    {
      Header: "Full Name",
      accessor: (data) => (
        <>
          <span>
            {data?.first_name} {data?.last_name}
          </span>
        </>
      ),
    },
    {
      Header: "Created At",
      accessor: (data) => (
        <>
          <span>{moment(data?.created_at).format("MMM DD, yyyy hh:mm A")}</span>
        </>
      ),
    },
    {
      Header: "Role",
      accessor: (data) => (
        <>
          {data?.Roles?.map((role) => {
            return <span key={role?.id}>{role.name}</span>;
          })}
        </>
      ),
    },
    {
      Header: "User Group",
      accessor: "userGroup",
    },
    {
      Header: "Status",
      accessor: (data) => (
        <>
          <span
            className={`active-btn ${data?.is_active === 0 ? "light-gray" : "light-green"
              }`}
          >
            {data?.is_active === 0 ? "Deactive" : "Active"}
          </span>
        </>
      ),
    },
    {
      Header: "Action",
      disableSortBy: true,
      accessor: (data) => (
        <div className="dropdown action-dropdown user-table-dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img src={ActionImg} alt="" />
          </button>
          <ul className="dropdown-menu">
            <li
              className="dropdown-item mt-1"
              onClick={() => {
                setCurrentModal("activateDeactivateUser");
                setuserId(data?.uuid);
              }}
            >
              <span>
                <img
                  className={`trnsfomr user-table-drow-img ${data?.is_active === 1 ? "" : "activate-img"
                    }`}
                  src={data?.is_active === 1 ? plusicnImg : active_icon}
                  alt=""
                />
              </span>
              {data?.is_active === 1 ? "Deactivate" : "Activate"}
            </li>
            {RoleRightsForModule("Update", "Users") &&
              <li
                className="dropdown-item mt-1"
                onClick={() => {
                  setCurrentModal("editUserModal");
                  setuserId(data?.uuid);
                }}
              >
                <span>
                  <img src={edit} alt="" />
                </span>
                Edit
              </li>}
            {RoleRightsForModule("Delete", "Users") && <li
              className="dropdown-item mt-1"
              onClick={() => {
                setCurrentModal("deleteUserModal");
                setuserId(data?.uuid);
              }}
            >
              <span>
                <img src={trashImg} alt="" />
              </span>
              Delete
            </li>}
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div>
      <ReactTable
        columns={columns}
        data={userList?.length > 0 ? userList : []}
        currentPage={currentPage}
        perPage={perPage}
        totalCount={total_records}
        handlePerPage={handleTotalPage}
        // isCheckBox={true}
        onPageChange={(page) => {
          handleCurrentPage(page);
        }}
        className="mangeuser-table"
      />
      {currentModal === "activateDeactivateUser" && (
        <ConfirmationModal
          title={"Activate/Deactivate Confirmation"}
          isOpen={currentModal === "activateDeactivateUser"}
          toggle={toggleModal}
          onConfirm={handleActivateDeactivate}
          message="Are you sure you want to Activate/Deactivate this document?"
        />
      )}
      {currentModal === "deleteUserModal" && (
        <ConfirmationModal
          title={"Delete Confirmation"}
          isOpen={currentModal === "deleteUserModal"}
          toggle={toggleModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this user?"
        />
      )}
      {currentModal === "editUserModal" && (
        <AddUserModal
          toggleFunction={toggleModal}
          isVisible={currentModal === "editUserModal"}
          userId={userId}
          isFromAllUsers={true}
          setCurrentActiveTab={setCurrentActiveTab}
        />
      )}
    </div>
  );
};

export default AllUsers;
